// Tiptap content lands as HTML (`<p>…</p>`, `<ul><li>…`, etc.) but the diff compares plain text.
// Convert block boundaries to blank lines so paragraphs survive, then strip the remaining tags.
export const htmlToText = (html: string | null | undefined): string => {
  if (!html) {
    return '';
  }
  const withBreaks = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h[1-6]|blockquote|tr)>/gi, '\n\n');
  const text = new DOMParser().parseFromString(withBreaks, 'text/html').body.textContent ?? '';
  return text.replace(/\n{3,}/g, '\n\n').trim();
};
